import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Modal from "@mui/material/Modal";

import { Table, DatePicker, Button, Input, Select, List, Modal as AntdModal, message, Checkbox } from 'antd';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { confirm } = AntdModal;
const { Option } = Select;
const { RangePicker } = DatePicker;

import { withRouter } from "react-router-dom";
import axios from "axios";
import FileCard from "../common/FileCard";
import FlowModal from "../common/FlowModal";
import DiagramModal from "../common/DiagramModal";
import LabelModal from "../common/LabelModal";
import TranslateModal from "../common/TranslateModal";
import ToTop from "../common/ToTop";
import {
  getAllFileList,
  getAllLableList,
  collectFile,
  getUserInfo,
  addLabelToFile,
  cancelCollectFile,
  delelteFileLabel,
  addCollectLabel,
  getZgfxLableList,
} from "../../actions/subscribe";
import { searchFileList, fileDownloadSize } from "../../actions/index"
import InfiniteScroll from "react-infinite-scroll-component";

import {
  getLabelId,
  getCollectId,
  getUserFileLabelList,
} from "../../utils/common";
import MuiAlert from "@mui/material/Alert";


import store from "../../store";
import Title from "antd/lib/skeleton/Title";
import { types } from "@babel/core";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      marginTop: "12px",
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    listMessage: {
      paddingLeft: "30px",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {},
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "97px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "0 !important",
    },
    select: {
      width: '100%'
    },
    grayBtn: {
      width: "97px",
      height: "40px",
      marginLeft: "18px !important",
      background: "#fff !important",
      borderRadius: "2px !important",
      border: "1px solid #d9d9d9 !important",
      color: "#0F25D1 !important",
      boxShadow: "none !important",
    },
    container: {
    },
    tabTop: {
      height: "20px"
    },
    list: {
      paddingRight: "16px",
      width: "1px",
      "&.hide-time": {
        paddingLeft: "16px",
      },
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    showBtn: {
      width: "82px",
      height: "32px",
      padding: "0 !important",
      border: "1px solid #d9d9d9 !important",
      borderRadius: "2px",
      backgroundColor: "#fff !important",
      color: "rgba(0, 0, 0, .65) !important",
      fontSize: "14px",
      boxShadow: "none !important",
      "&.first": {
        marginRight: "10px",
      },
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      height: "22px",
      margin: "12px 0",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
      "& img": {
        marginRight: "3px",
        "&.hide": {
          transform: "rotate(-90deg)",
        },
      },
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    categoryLine: {
      height: "46px",
      padding: "0 7px",
      borderBottom: "1px dashed #d8d8d8",
      overflow: "hidden",
      "&.show": {
        height: "auto",
      },
    },
    textBtn: {
      color: '#444',
      padding: '0 5px',
      "&:hover": {
        color: '#1890ff !important'
      }
    },
    linkBtn: {
      color: '#1890ff !important'
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    },
    redText: {
      color: '#f00'
    },
    greenText: {
      color: '#07AEA0'
    },
    modalBox: {
      top: 'calc(50% - 82px)',
    },
    
  };
};

class SearchFilePage extends Component {
  state = {
    tabList: [
      {
        title: '法律法规',
        type: '法律法规'
      },
      {
        title: '法规',
        type: '法规'
      },
      {
        title: '标准',
        type: '标准'
      },
      {
        title: '指导原则',
        type: '指导原则'
      },
    ],
    orgnizationList: [
      {
        ID: '香港',
        Name: '香港'
      },
      {
        ID: '澳门',
        Name: '澳门'
      },
      {
        ID: '台湾',
        Name: '台湾'
      },
      {
        ID: 'MFDS',
        Name: 'MFDS'
      },
      {
        ID: 'PMDA',
        Name: 'PMDA'
      },
      {
        ID: 'FDA',
        Name: 'FDA'
      },
      {
        ID: 'EUR',
        Name: 'EUR'
      },
    ],
    translateForm: {
      from: 'zh',
      to: 'en',
      auto: true
    },
    isZGFX: false, // 是否直观复兴
    showTab: false,
    tabIndex: 0,
    searchType: "",
    keyword: "",
    error: "",
    search_filters: {},
    is_all: 0,
    count: 0,
    title: "",
    userId: "", //用户id
    username: "", //用户名
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    openMessage: "",
    errorMessage: "",
    // push: true,
    openModal: false,
    openDiagramModal: false,
    openTranslateModal: false, // 翻译弹框
    translateFile: {},
    showFile: false,
    showTimeLine: true, // 是否展示时间线
    highText: false,
    modalTitle: "",
    parent_lable_id: 1,
    fileList: [],
    labelList: [],
    labelArr: [],
    tagList: [],
    tagArr: [],
    collectFileId: [],
    collectLabelId: [],
    baseFileId: "", // 图谱根节点文件id
    showAll: false,
    hideSearchBtn: false, //隐藏智能搜索按钮
    flowModal: false, // 分类流程
    filterName: "", // 分类流程类型
    medical_file: "",
    fileType: "",
    updateTime: '',
    searchHistoryList: [],
    form: {
      type: "",
      keyword: "",
      medical_file_publish_orgnization: undefined,
      medical_file_law_status: "",
      medical_file_admin_location: undefined,
      medical_file_publish_date: [],
    },
    defaultForm: { // 默认值
      type: "",
      keyword: "",
      medical_file_publish_orgnization: undefined,
      medical_file_law_status: "",
      medical_file_admin_location: undefined,
      medical_file_publish_date: [],
    },
    labelObj: { // 筛选项key - label对应关系
      type: '搜索类型',
      keyword: '关键词',
      medical_file_publish_orgnization: "发布机构",
      medical_file_law_status: "立法阶段",
      medical_file_admin_location: "管辖地域",
      medical_file_publish_date: "发布时间",
    },
    labelListObj: { 
      type: 'searchTypeList',
      medical_file_admin_location: 'labelList'
    },
    scrollObj: {x: 1660, y: 500},
    selectKeys: ['type', 'labelList'],
    showOtherSearch: false,
    searchTypeList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'all',
        Name: '全文搜索'
      },
      {
        ID: 'ai',
        Name: '智能检索'
      },
    ],
    loading: false,
    data: [],
    columns: [],
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      current: 1,
      pageSize: 10,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
    },
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1660,
        y: height - lineHeight - 270
      }
    })
  }

  getCollectStatus = (id) => {
    let index = this.state.collectFileId.findIndex(v => {
      return v == id
    })
    return index > -1 ? '取消收藏' : '收藏'
  }

  getColumns = () => {
    let list = [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 280,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.doCollect(row)}>
                {
                  this.getCollectStatus(row.base_file_id)
                }
              </Button>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.dfs_url, row.file_name)}>下载</Button>
              {
                row.isTranslate ? 
                <>
                  <Button type="text" className={this.props.classes.textBtn}>查看翻译件</Button>
                  <Button type="text" className={this.props.classes.textBtn} onClick={() => this.openTranslate(row)}>重新翻译</Button>
                </> :
                <Button type="text" className={this.props.classes.textBtn} onClick={() => this.openTranslate(row)}>在线翻译</Button>
              }
              {
                row.is_referenced &&
                <Button type="text" className={[this.props.classes.textBtn, this.props.classes.linkBtn].join(' ')} onClick={() => this.handleDiagram(row.base_file_id)}>参考件</Button>
              }
              {
                this.state.isZGFX && (this.state.fileType == '海外法规' || this.state.showOtherSearch) &&
                <Button className={this.props.classes.textBtn} type="text" onClick={() => this.handFlow(row)}>发起分类</Button>
              }
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 130,
        render: (text, row) => row.file_category
      },
      {
        title: '文件名称',
        dataIndex: 'file_name',
        key: 'file_name',
        width: 370,
        render: (text, row) => {
          let fileName = row.file_name
          let isNode = false
          let nodeItem = null
          if (this.state.form.keyword && this.state.fileType == '海外法规') {
            isNode = true
            let keyword = this.state.form.keyword

            const regex = new RegExp(keyword, 'gi');
            let fileList = fileName.split(regex);

            let redSpan = <span className={this.props.classes.redText}>{keyword}</span>
            let newList = []
            fileList.forEach((v, i) => {
              newList.push(v)
              if (i != fileList.length - 1) {
                newList.push({
                  flag: true
                })
              }
            })
            nodeItem = <>
              {
                newList.map((v)=> {
                  return v.flag ? redSpan : v
                })
              }
            </>
          }
          return <a className={this.props.classes.linkText} onClick={() => this.previewFile(row.dfs_url)}>{isNode ? nodeItem : fileName}</a>
        }
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file_publish_orgnization',
        width: 140,
      },
      {
        title: '发布时间',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        width: 140,
        render: (text, row) => {
          let data = row.medical_file_publish_date || ''
          return data.substring(0, 10)
        }
      },
      {
        title: '立法阶段',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file_law_status',
        width: 120,
      },
 
      {
        title: '网页链接',
        dataIndex: 'medical_file_website_link',
        key: 'medical_file_website_link',
        width: 240,
        render: (text, row) => (<a target="_blank" href={row.medical_file_website_link}>{row.medical_file_website_link}</a>)
      },
    ]
    if (this.state.fileType == '对比文件') {
      this.setState({
        columns: [
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 200,
            align: 'center',
            render: (text, row) => {
              return (
                <>
                  {/* <Button type="text" className={this.props.classes.textBtn}>翻译</Button> */}
                  <Button type="text" className={this.props.classes.textBtn} onClick={() => this.doCollect(row)}>
                    {
                      this.getCollectStatus(row.base_file_id)
                    }
                  </Button>
                  <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.dfs_url, row.file_name)}>下载</Button>
                  {
                    row.is_referenced &&
                    <Button type="text" className={[this.props.classes.textBtn, this.props.classes.linkBtn].join(' ')} onClick={() => this.handleDiagram(row.base_file_id)}>参考件</Button>
                  }
                  {
                    this.state.isZGFX && (this.state.fileType == '海外法规' || this.state.showOtherSearch) &&
                    <Button className={this.props.classes.textBtn} type="text" onClick={() => this.handFlow(row)}>发起分类</Button>
                  }
                </>
              )
            }
          },
          {
            title: '文件类型',
            dataIndex: 'file_category',
            key: 'file_category',
            width: 160,
            render: (text, row) => row.file_category
          },
          {
            title: '文件名称',
            dataIndex: 'file_name',
            key: 'file_name',
            width: 700,
            render: (text, row) => (<a  className={this.props.classes.linkText} onClick={() => this.previewFile(row.dfs_url)}>{row.file_name}</a>)
          },
          {
            title: '发布机构',
            dataIndex: 'medical_file_publish_orgnization',
            key: 'medical_file_publish_orgnization',
            width: 300,
          },
        ]
      })
    } else if (this.state.fileType == '法规' ) {
      list.splice(6, 0, {
        title: '性质类型',
        dataIndex: 'regulation_file_type',
        key: 'regulation_file_type',
        width: 120,
      })
      this.setState({
        columns: list
      })
    } else if (this.state.fileType == '标准') {
      list.splice(6, 0, {
        title: '性质类型',
        dataIndex: 'standard_file_type',
        key: 'standard_file_type',
        width: 120,
      })
      this.setState({
        columns: list
      })
    } else if (this.state.fileType == '海外法规') {
      list.splice(1, 1)
      this.setState({
        columns: list
      })
    } else {
      this.setState({
        columns: list
      })
    }

  }

  componentDidMount() {
    this.getTableHeight()
    this.queryLable()

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let companyName = localStorage.getItem('companyName')
    this.setState({
      isZGFX: companyName === 'zgfx'
    })

    let pathname = this.props.location.pathname;
    let title = "";
    let fileType = "";
    let showTab = false
    let showOtherSearch = false
    let parent_lable_id = 1
    switch (pathname) {
      case "/commonProblems":
        fileType = "共性问题解答";
        title = "共性问题解答";
        break;
      case "/issues":
        fileType = "上市后问题";
        title = "上市后问题";
        break;
      case "/compare":
        fileType = "对比文件";
        title = "对比文件";
        break;
      case "/fda":
        fileType = "海外法规";
        title = "海外法规";
        parent_lable_id = 2;
        break;
      case "/law":
        fileType = "法规";
        title = "法规";
        showOtherSearch = true;
        break;
      case "/standard":
        fileType = "标准";
        title = "标准";
        showOtherSearch = true;
        break;
      case "/search":
        fileType = "法律法规";
        title = "法律法规";
        showOtherSearch = true;
        showTab = true
        break;
      case "/guidance":
        fileType = "指导原则";
        title = "指导原则";
        showOtherSearch = true;
        this.setState({ hideSearchBtn: true });
        break;
      default:
        break;
    }

    let search = decodeURI(this.props.location.search) || ''
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          keyword: urlKeyword,
          type: 'ai'
        }
      })
    }


    this.setState(
      {
        username: store.getState().auth.username,
        fileType: fileType,
        title: title,
        showTab: showTab,
        parent_lable_id: parent_lable_id,
        showOtherSearch: showOtherSearch,
      },
      () => {
        this.getColumns()
        this.queryUserInfo();
        this.searchForm();
      }
    );
  }

  resetForm = () => {
    this.setState({
      form: {
        type: "",
        keyword: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  searchForm = () => {
    let paginationObj = {
      ...this.state.paginationObj,
      current: 1
    }
    this.setState({
      paginationObj: paginationObj
    }, () => this.loadMore())
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'medical_file_publish_date') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    }, () => { this.getTableHeight() })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
        paginationObj: pagination
      },
      () => {
        this.loadMore();
      }
    );
  };



  downloadFile = (url, fileName) => {
    if (this.state.fileType == '标准') {
      let application_id = localStorage.getItem('applicationId')
      fileDownloadSize({
        application_id: application_id,
        file_path: url
      }).then(res => {
        let count = res.result || 0
        let lastCount = 20 - count
        if (lastCount < 0) {
          lastCount = 0
        }
        if (isNaN(lastCount) || lastCount > 20) {
          lastCount = 20
        }
        confirm({
          title: '提示',
          className: this.props.classes.modalBox,
          content: <div>当日标准文件剩余下载次数<span className={lastCount == 0 ? this.props.classes.redText : this.props.classes.greenText}>({lastCount}/20)</span>次</div>,
          onOk: () => {
            if (lastCount > 0) {
              this.doDownload(url, fileName)
              fileDownloadSize({
                application_id: application_id,
                file_path: url,
                operation_type: '下载'
              })
            }
          }
        })
      })
    } else {
      this.doDownload(url, fileName)
    }
  };

  doDownload = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  }

  //查询用户信息;
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          this.setState({
            userId: userData.id,
            collectFileId: userData.favorite_basefiles.map((v) => {
              return v.basefile_id;
            }),
            collectLabelId: userData.favorite_lables.map((v) => {
              return v.lable_id;
            }),
          });
          this.getColumns()
        }
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };

  queryLable = () => {
    const param = {
      lable_category_type: "高级筛选",
      is_shown: true,
    };
    getAllLableList(param).then((res) => {
      let data = res.results.find(v => {
        return v.lable_category_name == '管辖地域'
      })
      this.setState({
        labelList: data.lables
      });
    });
  };
  queryZgfxLable = (fileType) => {
    const param = {
      fileType: fileType,
    };
    getZgfxLableList(param).then((res) => {
      this.setState({
        labelList: res.results,
      });
    });
  };

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  loadMore = () => {
    this.setState({
      loading: true
    })

    let searchType = ""
    if (this.state.form.type == "all") {
      searchType = "全文检索"
    } else if (this.state.form.type == 'ai') {
      searchType = '智能检索'
    }


    let start = undefined
    let end = undefined
    if (this.state.form.medical_file_publish_date && this.state.form.medical_file_publish_date.length > 0) {
      start = this.state.form.medical_file_publish_date[0].format("YYYY-MM-DD")
      end = this.state.form.medical_file_publish_date[1].format("YYYY-MM-DD")
    }

    const param = {
      keyword: this.state.form.keyword,
      search_type: searchType,
      file_category_type: this.state.fileType,
      medical_file_publish_orgnization: this.state.form.medical_file_publish_orgnization,
      medical_file_law_status: this.state.form.medical_file_law_status,
      medical_file_admin_location: this.state.form.medical_file_admin_location,
      medical_file_publish_date_from: start,
      medical_file_publish_date_to: end,
      page: this.state.paginationObj.current,
      pageSize: this.state.paginationObj.pageSize
    };
    searchFileList(param).then((res) => {
      if (res && res.result) {
        let data = res.result
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };


  changeShow = (i) => {
    let show = this.state.labelList[i].showDetail;
    let newLabelList = [].concat(this.state.labelList);
    if (show) {
      newLabelList[i].showDetail = false;
    } else {
      newLabelList[i].showDetail = true;
    }
    let showAll = this.state.showAll;
    let size = newLabelList.filter((v) => {
      return v.showDetail;
    }).length;
    if (size == 0) {
      showAll = false;
    }
    if (size == newLabelList.length) {
      showAll = true;
    }
    this.setState({
      labelList: newLabelList,
      showAll: showAll,
    });
  };

  showAllDetail = () => {
    let newLabelList = [].concat(this.state.labelList);
    newLabelList.forEach((v) => {
      v.showDetail = !this.state.showAll;
    });
    this.setState({
      labelList: newLabelList,
      showAll: !this.state.showAll,
    });
  };


  handleClose = () => {
    this.setState({
      openModal: false,
    });
    this.queryUserInfo();
  };

  //收藏文件
  handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagArr.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    //获取标签id
    getLabelId(tag, this.state.userId).then((labelId) => {
      //打标签
      addLabelToFile({
        base_file: this.state.dataId,
        lable: labelId,
        lable_update_user: this.state.userId,
        parent_lable_id: this.state.parent_lable_id
      }).then((resp) => {
        if (resp.id) {
          this.setState({
            tagArr: this.state.tagArr.concat([
              {
                lable_content: tag,
                lable_id: labelId,
              },
            ]),
          });
        }
      });

      //收藏标签
      if (this.state.collectLabelId.includes(labelId) == false) {
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
          parent_lable_id: this.state.parent_lable_id
        });
      }
    });
  };

  handRemove = (id) => {
    // getFileLabelId(this.state.dataId, id, this.state.userId).then(fileLabelId => {
    delelteFileLabel(id);
    // })
    let tagArr = [].concat(this.state.tagArr);
    let index = tagArr.findIndex((v) => {
      return v.lable_id === id;
    });
    tagArr.splice(index, 1);
    this.setState({
      tagArr: [].concat(tagArr),
    });
  };

  //收藏、取消搜藏
  doCollect = (row) => {
    let index = this.state.collectFileId.findIndex(v => {
      return v == row.base_file_id
    })
    if (index > -1) {
      confirm({
        title: '确认',
        content: '确认取消收藏？',
        onOk: () => {
          this.handCancelCollect(row.base_file_id)
        }
      })
    } else {
      this.handCollect(row.base_file_id)
    }
  }

  //收藏文件
  handCollect = (id) => {
    this.setState({
      openModal: true,
      modalTitle: "文件收藏",
      dataId: id,
      tagArr: [],
    });
    //收藏文件
    collectFile({
      base_file: id,
      user: this.state.userId,
    }).then(() => {
      this.queryUserInfo();
    })
  };
  //取消收藏
  handCancelCollect = (id) => {
    getCollectId(id, this.state.userId).then((collectId) => {
      cancelCollectFile(collectId).then((res) => {
        if (res && res.message) {
          message.warning(res.message)
        } else {
          message.success('取消成功')
          this.queryUserInfo();
        }
      });
    });
  };
  //管理标签
  handSetting = (id) => {
    getUserFileLabelList(id, this.state.userId).then((list) => {
      this.setState({
        openModal: true,
        dataId: id,
        modalTitle: "管理标签",
        tagArr: list,
      });
    });
  };
  // 分类流程
  handFlow = (data) => {
    this.setState({
      flowModal: true,
      medical_file: data,
      filterName: data.file_category,
    });
  };
  closeFlow = () => {
    this.setState({
      flowModal: false,
    });
  };
  //图谱
  handleDiagram = (id) => {
    this.setState({
      openDiagramModal: true,
      baseFileId: id,
    });
  };
  //关闭弹框
  handleClose = () => {
    this.setState({
      openModal: false,
      openDiagramModal: false,
    });
    this.queryUserInfo();
  };

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };


  changeTab = (data, i) => {
    this.setState(
      {
        fileType: data.type,
        tabIndex: i,
        title: data.title
      },
      () => {
        this.getColumns()
        this.loadMore();
      }
    );
  }

  openTranslate = (data) => {
    this.setState({
      openTranslateModal: true,
      translateFile: data
    })
  }
  handleCloseTranslate = () => {
    this.setState({
      openTranslateModal: false
    })
  }

  backTranslate = () => {
    this.setState({
      showFile: false,
    })
  }

  doTranslate = () => {
    sessionStorage.setItem('translateFile', JSON.stringify(this.state.translateFile))
    this.props.history.push('/translate')
  }

  toViewFile = (fileUrl, twoLangFileUrl) => {
    sessionStorage.setItem('translateFile', JSON.stringify(this.state.translateFile))
    sessionStorage.setItem('translatedFile', fileUrl)
    sessionStorage.setItem('translateTwoLangFileUrl', twoLangFileUrl)
    this.props.history.push('/translate')
  }

  toTranslate = () => {
    this.setState({
      showFile: true
    })
  }



  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">搜索类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.type}
                onChange={(e) => this.onChangeForm(e, 'type')} 
              >
                {
                  this.state.searchTypeList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入关键词"/>
            </div>
            {
              this.state.showOtherSearch && 
              <>  
              <div className="form-item">
                <div className="form-label">发布机构</div>
                <Input  value={this.state.form.medical_file_publish_orgnization}
                  allowClear
                  onChange={(e) => this.onChangeForm(e.target.value, 'medical_file_publish_orgnization')} 
                  placeholder="请输入发布机构"/>
              </div>
              <div className="form-item">
                <div className="form-label">发布时间</div>
                <RangePicker
                  allowClear
                  value={this.state.form.medical_file_publish_date}
                  onChange={(value) => this.onChangeForm(value, 'medical_file_publish_date')}
                />
              </div>
              <div className="form-item">
                <div className="form-label">立法阶段</div>
                <Input  value={this.state.form.medical_file_law_status}
                  allowClear
                  onChange={(e) => this.onChangeForm(e.target.value, 'medical_file_law_status')} 
                  placeholder="请输入立法阶段"/>
              </div>
              <div className="form-item">
                <div className="form-label">管辖地域</div>
                <Select
                  allowClear
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.medical_file_admin_location}
                  onChange={(e) => this.onChangeForm(e, 'medical_file_admin_location')} 
                >
                  {
                    this.state.labelList.map((v, i) => {
                      return (
                        <Option value={v.lable_content} key={i}>{v.lable_content}</Option>
                      )
                    })
                  }
                </Select>
              </div>
              </>
            }
            {
              this.state.fileType == '海外法规' &&
              <>
                <div className="form-item">
                  <div className="form-label">发布机构</div>
                  <Select
                    allowClear
                    className={classes.select}
                    placeholder="请选择"
                    value={this.state.form.medical_file_publish_orgnization}
                    onChange={(e) => this.onChangeForm(e, 'medical_file_publish_orgnization')} 
                  >
                    {
                      this.state.orgnizationList.map((v, i) => {
                        return (
                          <Option value={v.ID} key={i}>{v.Name}</Option>
                        )
                      })
                    }
                  </Select>
                </div>
                <div className="form-item">
                  <div className="form-label">发布时间</div>
                  <RangePicker
                    allowClear
                    value={this.state.form.medical_file_publish_date}
                    onChange={(value) => this.onChangeForm(value, 'medical_file_publish_date')}
                  />
                </div>
              </>
            }
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search"  id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">{this.state.title}</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            {
              this.state.showTab && 
              <div className="main-top">
                <div>
                  {
                    
                    this.state.tabList.map((v, i) => (
                      <span
                        key={i}
                        onClick={() => this.changeTab(v, i)}
                        className={[
                          "main-tab",
                          this.state.tabIndex == i ? "active" : "",
                        ].join(" ")}
                      >
                        {v.title}
                      </span>
                    ))
                  }
                </div>
              </div>
            }
            {
              !this.state.showTab &&
              <div className={classes.tabTop}></div>
            }
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>

        {/* <ToTop /> */}

        <Modal
            open={this.state.openModal}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <LabelModal
                width={520}
                title={this.state.modalTitle}
                close={this.handleClose}
                tagArr={this.state.tagArr}
                handAdd={this.handAdd}
                handRemove={this.handRemove}
                dataId={this.state.dataId}
                parent_lable_id={this.state.parent_lable_id}
              />
            </div>
          </Modal>

          <Modal
            open={this.state.flowModal}
            onClose={this.closeFlow}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <FlowModal
                medical_file={this.state.medical_file}
                filterName={this.state.filterName}
                close={this.closeFlow}
              />
            </div>
          </Modal>
          <Modal
            open={this.state.openDiagramModal}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <DiagramModal fileId={this.state.baseFileId} />
            </div>
          </Modal>

          <TranslateModal
            openModal={this.state.openTranslateModal}
            handleClose={this.handleCloseTranslate}
            showFile={this.state.showFile}
            translateFile={this.state.translateFile}
            doTranslate={this.doTranslate}
            toViewFile={this.toViewFile}
            backTranslate={this.backTranslate}
            toTranslate={this.toTranslate}
          ></TranslateModal>
          

          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={this.state.openMessage}
            onClose={this.closeMessage}
          >
            <MuiAlert elevation={6} variant="filled" severity="warning">
              {this.state.errorMessage}
            </MuiAlert>
          </Snackbar>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(SearchFilePage));
